import CustomButton from "@Common/CustomButton"
import { ActionButtonsWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import Input from "@Common/input"
export default function ActionButtons() {
	const { t } = useTranslation()
	return (
		<ActionButtonsWrapper>
			<div className='firstSection'>
				<div className='inputName'>
					<Input
						name='Name'
						registerOptions={{
							required: {
								value: true,
								message: t("COMMON.REQUIRED"),
							},
						}}
					/>
				</div>
				<Input
					name='description'
					placeholder={t("AutomationCentre.This_text_is_an_example")}
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
					}}
				/>
			</div>
			<CustomButton
				type='submit'
				label={t("OwnerManagement.Save")}
				withBG
				customPadding='12px 27px'
				borderRadius='8px'
			/>
		</ActionButtonsWrapper>
	)
}
